import {
  PAYMENT_REQUEST_LIST,
  PAYMENT_REQUEST_LIST_SUCCESS,
  PAYMENT_REQUEST_LIST_FAIL,
  PAYMENT_REQUEST_PREVIEW,
  PAYMENT_REQUEST_PREVIEW_SUCCESS,
  PAYMENT_REQUEST_PREVIEW_FAIL,
  PAYMENT_REQUEST_PREDICTED,
  PAYMENT_REQUEST_PREDICTED_SUCCESS,
  PAYMENT_REQUEST_PREDICTED_FAIL,
  PAYMENT_REQUEST_UNCOLLECTABLE,
  PAYMENT_REQUEST_UNCOLLECTABLE_SUCCESS,
  PAYMENT_REQUEST_UNCOLLECTABLE_FAIL,
  PAYMENT_REQUEST_DATA,
  PAYMENT_REQUEST_DATA_SUCCESS,
  PAYMENT_REQUEST_DATA_FAIL,
  PAYMENT_REQUEST_CREATE,
  PAYMENT_REQUEST_CREATE_SUCCESS,
  PAYMENT_REQUEST_CREATE_FAIL,
  PAYMENT_REQUEST_SEARCH,
  PAYMENT_REQUEST_SEARCH_SUCCESS,
  PAYMENT_REQUEST_SEARCH_FAIL,
  PAYMENT_REQUEST_VOID,
  PAYMENT_REQUEST_VOID_SUCCESS,
  PAYMENT_REQUEST_VOID_FAIL,
} from "./actionType";

const initialState = {
  //PAYMENT_REQUEST_LIST
  paymentRequestList: [],
  paymentRequestListLoading: false,
  paymentRequestListError: null,

  //PAYMENT_REQUEST_PREVIEW
  paymentRequestPreview: [],
  paymentRequestPreviewLoading: false,
  paymentRequestPreviewError: null,

  //PAYMENT_REQUEST_PREDICTED
  paymentRequestPredicted: [],
  paymentRequestPredictedLoading: false,
  paymentRequestPredictedError: null,

  //PAYMENT_REQUEST_UNCOLLECTABLE
  paymentRequestUncollectable: [],
  paymentRequestUncollectableLoading: false,
  paymentRequestUncollectableError: null,

  //PAYMENT_REQUEST_DATA
  paymentRequestData: {},
  paymentRequestDataLoading: false,
  paymentRequestDataError: null,

  //PAYMENT_REQUEST_CREATE
  paymentRequestCreate: {},
  paymentRequestCreateLoading: false,
  paymentRequestCreateError: null,

  //PAYMENT_REQUEST_SEARCH
  paymentRequestSearch: [],
  paymentRequestSearchLoading: false,
  paymentRequestSearchError: null,

  //PAYMENT_REQUEST_VOID
  paymentRequestVoid: {},
  paymentRequestVoidLoading: false,
  paymentRequestVoidError: null,
};

const PaymentRequest = (state = initialState, action) => {
  switch (action.type) {
    //PAYMENT_REQUEST_LIST
    case PAYMENT_REQUEST_LIST:
      return {
        ...state,
        paymentRequestListLoading: true,
        paymentRequestListError: null,
      };
    case PAYMENT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        paymentRequestList: action.payload,
        paymentRequestListLoading: false,
      };
    case PAYMENT_REQUEST_LIST_FAIL:
      return {
        ...state,
        paymentRequestListLoading: false,
        paymentRequestListError: action.payload,
      };
    //PAYMENT_REQUEST_PREVIEW
    case PAYMENT_REQUEST_PREVIEW:
      return {
        ...state,
        paymentRequestPreviewLoading: true,
        paymentRequestPreviewError: null,
      };
    case PAYMENT_REQUEST_PREVIEW_SUCCESS:
      return {
        ...state,
        paymentRequestPreview: action.payload,
        paymentRequestPreviewLoading: false,
      };
    case PAYMENT_REQUEST_PREVIEW_FAIL:
      return {
        ...state,
        paymentRequestPreviewLoading: false,
        paymentRequestPreviewError: action.payload,
      };
    //PAYMENT_REQUEST_PREDICTED
    case PAYMENT_REQUEST_PREDICTED:
      return {
        ...state,
        paymentRequestPredictedLoading: true,
        paymentRequestPredictedError: null,
      };
    case PAYMENT_REQUEST_PREDICTED_SUCCESS:
      return {
        ...state,
        paymentRequestPredicted: action.payload,
        paymentRequestPredictedLoading: false,
      };
    case PAYMENT_REQUEST_PREDICTED_FAIL:
      return {
        ...state,
        paymentRequestPredictedLoading: false,
        paymentRequestPredictedError: action.payload,
      };
    //PAYMENT_REQUEST_UNCOLLECTABLE
    case PAYMENT_REQUEST_UNCOLLECTABLE:
      return {
        ...state,
        paymentRequestUncollectableLoading: true,
        paymentRequestUncollectableError: null,
      };
    case PAYMENT_REQUEST_UNCOLLECTABLE_SUCCESS:
      return {
        ...state,
        paymentRequestUncollectable: action.payload,
        paymentRequestUncollectableLoading: false,
      };
    case PAYMENT_REQUEST_UNCOLLECTABLE_FAIL:
      return {
        ...state,
        paymentRequestUncollectableLoading: false,
        paymentRequestUncollectableError: action.payload,
      };
    //PAYMENT_REQUEST_DATA
    case PAYMENT_REQUEST_DATA:
      return {
        ...state,
        paymentRequestDataLoading: true,
        paymentRequestDataError: null,
      };
    case PAYMENT_REQUEST_DATA_SUCCESS:
      return {
        ...state,
        paymentRequestData: action.payload,
        paymentRequestDataLoading: false,
      };
    case PAYMENT_REQUEST_DATA_FAIL:
      return {
        ...state,
        paymentRequestDataLoading: false,
        paymentRequestDataError: action.payload,
      };
    //PAYMENT_REQUEST_CREATE
    case PAYMENT_REQUEST_CREATE:
      return {
        ...state,
        paymentRequestCreateLoading: true,
        paymentRequestCreateError: null,
      };
    case PAYMENT_REQUEST_CREATE_SUCCESS:
      return {
        ...state,
        paymentRequestCreate: action.payload,
        paymentRequestCreateLoading: false,
      };
    case PAYMENT_REQUEST_CREATE_FAIL:
      return {
        ...state,
        paymentRequestCreateLoading: false,
        paymentRequestCreateError: action.payload,
      };
    //PAYMENT_REQUEST_SEARCH
    case PAYMENT_REQUEST_SEARCH:
      return {
        ...state,
        paymentRequestSearchLoading: true,
        paymentRequestSearchError: null,
      };
    case PAYMENT_REQUEST_SEARCH_SUCCESS:
      return {
        ...state,
        paymentRequestSearch: action.payload,
        paymentRequestSearchLoading: false,
      };
    case PAYMENT_REQUEST_SEARCH_FAIL:
      return {
        ...state,
        paymentRequestSearchLoading: false,
        paymentRequestSearchError: action.payload,
      };
    //PAYMENT_REQUEST_VOID
    case PAYMENT_REQUEST_VOID:
      return {
        ...state,
        paymentRequestVoidLoading: true,
        paymentRequestVoidError: null,
      };
    case PAYMENT_REQUEST_VOID_SUCCESS:
      return {
        ...state,
        paymentRequestVoid: action.payload,
        paymentRequestVoidLoading: false,
      };
    case PAYMENT_REQUEST_VOID_FAIL:
      return {
        ...state,
        paymentRequestVoidLoading: false,
        paymentRequestVoidError: action.payload,
      };
    default:
      return state;
  }
};
export default PaymentRequest;
